import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import routes from 'constants/routes'
import { Clock } from 'lucide-react'

/**
 * Persistent banner for trial/marketing accounts showing days remaining and a
 * conversion CTA. Renders nothing for non-trial accounts. Mounted in the app
 * shell so it's visible across the whole app.
 */
const TrialBanner = () => {
	const navigate = useNavigate()
	const userInfo = useSelector((state: any) => state.userLogin?.userInfo)

	if (!userInfo || userInfo.accountType !== 'trial' || !userInfo.trialExpiresAt) {
		return null
	}

	const msLeft = new Date(userInfo.trialExpiresAt).getTime() - Date.now()
	const daysLeft = Math.max(0, Math.ceil(msLeft / (24 * 60 * 60 * 1000)))
	const expired = msLeft <= 0

	return (
		<div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-primary/10 px-4 py-2 text-center text-sm text-[#052852]">
			<span className="inline-flex items-center gap-1.5 font-medium">
				<Clock className="h-4 w-4" />
				{expired
					? 'Your preview has ended.'
					: `${daysLeft} ${daysLeft === 1 ? 'day' : 'days'} left in your preview.`}
			</span>
			<button
				type="button"
				onClick={() => navigate(routes.CONVERT_ACCOUNT)}
				className="rounded-full bg-primary px-3 py-1 text-xs font-semibold text-primary-foreground transition-colors hover:opacity-90"
			>
				Create your account
			</button>
		</div>
	)
}

export default TrialBanner
